import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, NavParams, Platform, LoadingController, FabContainer } from 'ionic-angular';

import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';
import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';
import { Geolocation } from '@ionic-native/geolocation';

import { BaseListPage } from '../../providers/base-list-page';

declare var google: any;
declare var GeolocationMarker: any;
declare var $: any;

@Component({
  selector: 'page-consumer-business-list',
  templateUrl: 'consumer-business-list.html',
})
export class ConsumerBusinessListPage extends BaseListPage {
	@ViewChild('fab')fab : FabContainer;
	
	filePath: any;
	loader: any;
	
	loadingMsg: any = "Loading...";

	term: any = "null";
	categories: any = [];

	filter: any = "A";

	mapIsVisible: boolean = false;
	mapInitialized: boolean = false;

	map: any;
	currentLocationFound: boolean = false;
	currentLocationCoords: any;

	infoWindow: any;

	lastRequestReturnedValues: boolean = false;
	
	constructor(
		public utils: Utils,
		public navCtrl: NavController, 
		public mainService: ConsumerBusinessHandlerProvider,
		public navParams: NavParams,
		public loadingCtrl: LoadingController,
		public globals: Globals,
		private elRef: ElementRef,
		public platform: Platform,
		private geolocation: Geolocation
	) {
		super();

		this.filePath = this.globals.fileUrl;
	}

	ionViewDidLoad() {
		this.isLoading = true;

		this.loadingMsg = "Loading..."

		this.load(()=>{
			this.isLoading = false;
		});	
	}	

	gotoDetail(business){
		this.navCtrl.push(ConsumerBusinessDetailPage, {
			business: business,
			caller: this
		});
	}	

	search(ev){
		this.term = this.term = ev.target.value;	

		if(this.term=="" || !this.term)
			this.term = "null";
		
		this.params.page = 1;
		this.load(null);
	}

	doRefresh(refresher) {
		this.isRefreshing = true;
		this.params.page = 1;
		
	
		this.load(()=>{
			this.isRefreshing  = false;

		  	refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isFetchingMore = true;
		this.params.page++;

		this.load(()=>{
			infiniteScroll.complete();
		});
	}

	load(cb){
		this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

		this.params.cbAfter = cb;

		this.mainService.getBusinessMoney(this.params);
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-business-list/consumer-business-list.ts